
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import { basePort } from 'portfinder'
import { AddressEdit } from 'vant'
export default {
  ...zhLocale,
  route: {
    pending: '待处理',
    photo: '拖拽图片',
    login: '登录',
    mobileLogin: '手机端登录',
    project: '项目',
    detail: '深层水平位移详情页面',
    projInfo: '项目信息',
    dtuTask: 'DTU任务',
    dataDetail: '详情数据',
    monitorPoint: '监测点',
    curveChart: '监测点曲线图',
    monitorType: '监测点类型',
    task: '任务',
    caiji: '采集任务',
    dtuTaskMenu: 'DTU任务',
    warning: '预警推送',
    bigScreen: '大屏',
    vipLogin: '超级Vip',
    vipHome: '超级Vip首页',
    projectMenu: '项目',
    audit: '审核',
    device: '设备',
    certificateDownload: '合格证下载',
    documents: '文件',
    versionInfo: '版本及功能说明',
    user: '用户',
    report: '报表',
    getData: '获取数据',
    overview: '异步消息中间件',
    exceptions: '异常',
    buildingProj: '在监测',
    completedProj: '已完工',
    projectManagement: '项目管理',
    uncompletedAudit: '未审核',
    completedAudit: '已审核',
    downloadData: '下载资料',
    attentation: '注意事项',
    newReport: '报表',
    decidechongzhi: '物联网卡管理',
  },
  typelist: {
    water: '水位',
    datawater: '数字水位计',
    shuxiang: '竖向位移',
    yeya: '液压水准',
    yeya1: '液压水准2',
    yeye3: '液压水准3',
    yacha: '压差式静力水准EA-HHL',
    cidian: 'PTH203磁致伸缩静力水准仪',
    yeyaM: '液压水准EA-LP3(M)',
    shen: '深层水平位移',
    shened4ro: '深层水平位移EA-DHL4Pro',
    shende4: '深层水平位移EA-DHL4',
    shende4s: '深层水平位移EA-DHL4(CS)',
    shende3: '深层水平位移EA-DHL3',
    shende2: '深层水平位移EA-DHL2',
    shende1: '深层水平位移EA-DHL1',
    qingxie: '倾斜',
    qingjiao: '倾角计',
    dianjie: '电解质倾角计',

    liefeng: '裂缝',
    liefenbjianc: '裂缝监测',
    tuliao: '涂料裂缝',

    weiyi: '位移',
    laxian: '拉线式位移计',
    laxian2: '拉线式位移计EA-HLD2',
    jiguange: 'EA-LRF2激光测距仪',
    haomi: '毫米波雷达',
    jice: '激光测距仪',
    lsji: 'L2s激光测距仪',
    a100jiguang: 'A100／SK100激光测距仪',
    dianzu: '电阻式位移计',

    moni: '模拟量',

    power: '力',
    luogan: '螺杆轴力计',
    dianzu: '电阻式测力计',

    raodu: '挠度（竖向位移）',
    zhenlie: '阵列位移计',
    zhenliee4: '阵列位移计EA-DHL4Pro',

    shoulian: '收敛变形',
    yingli: '应力应变',
    dianzu: '电阻式应变计',
    zhenxuan2: '振弦式应变计EA-VSR2',
    zhenxuan3: '振弦式应变计EA-VSR3',
    zhenxuankai: '振弦式应变计（开发测试）',
    zhenxuanying: '振弦式应变计YS-VW1004',

    gang: '钢支撑轴力',
    easitong: 'EA-VSR3四通道485振弦读数仪',
    ea2sitong: 'EA-VSR2四通道485振弦读数仪',
    zhenkai: '485振弦读数仪（开发测试）',
    ysvw: 'YS-VW1004四通道振弦采集仪',

    hunni: '混凝土支撑轴力',
    maogan: '锚杆及土钉内力',
    kunxi: '孔隙水／土压力',

    wenshidu: '温湿度',
    bweduji: 'TH10S-B温湿度计',
    ifdc: 'IFDC21-PT100',
    rs: 'RS15-C',

    fengsu: '风速风向',
    sncf: 'SN-CFSFX-N01',

    guangxue: '光学雨量',
    sngy: 'SN-GYL-N01',
    zhendong: '振动与倾斜',

    turang: '土壤温度水分',
    turangwendu: '土壤温度水分变送器RS-WS-N01-TR-1',

    zhendong2: '振动与倾斜2',
    boan: '驳岸',
    shijue: '视觉位移',
    acn: 'ACW-GNSS800',
    gnss: 'GNSS／RTK'

  },
  heaher:{
    picshangshuan:'图纸上传',
    shijueweiyi:'视觉位移',
    boan:'驳岸',
    zhendongjiance2:'振动监测仪2',
   zhendongjiance:'振动与倾斜',
   jiancedian:'监测点',
   dturenwu:'DTU任务',
   caijiduan:'采集端设置',
   DTUOn:'DTU绑定/解绑'


  },
  wulianwang:{
    proname:'项目名称',
    chaxun:'查询',
    resetchonbgz:'重置',
    index:'序号',
    shebeiID:'设备ID',
    shebeitype:'设备类型',
    iccid:'ICCID',
    wulianwangdata:'物联网到期日',
    shengchengorder:'生成订单',
    orderlist:'订单列表',
    qingselect:'请选择输入物联网设备',
    qingdecideid:'请选择输入设备ID',
    qingiccid:'请选择输入ICCID',
    shengvalue:'生成订单充值',
    qingxufei:'请输入续费时长',
    xufeikong:'续费时长不能为空',
    shunum:'请输入大于0的正整数',
    qingproname:'请输入项目名称',
    xufei:'续费时长',
    yue:'月',
    total:'总共',
    xiang:'项',
    yixuanze:'已选择',
    shenhe:'审核',
    chongzhi:'充值',
    dingdanbianhao:'订单编号',
    chongzhishi:'充值时长',
    shebeinum:'设备数量',
    orderstatus:'订单状态',
    chuangjiandata:'创建日期',
    caozuo:'操作',
    back:'返回上一页',
    chongzhidata:'充值后到期日',
    chongdata:'到期日',
    orderxiang:'订单详情',
    





  },
  login: {
    title: '用户登录',
    username: '用户名',
    password: '密码',
    captcha: '验证码',
    submit: '登录',
    Noaccount: '没有账号',
    forgetpass: '忘记密码',
    mobile: '手机登录',
    conpanyname: '公司名称',
    passconfirm: '确认密码',
    Confirm: '确认',
    phoneline: '手机端登录链接',
    registerphone: '请输入注册手机号',
    registerphonesuccess: '注册成功，工作人员将会进行审核，审核成功后将会通知您，请耐心等待',
    finesecird: '找回密码',
    phone: '手机号',
    register: '注册',
    getcaptcha: '获取验证码',
    selectLanguage: '选择语言',
    usernamePlaceholder: '请输入用户名',
    passwordPlaceholder: '请输入密码',
    captchaPlaceholder: '请输入验证码',
    companyPlaceholder: '请输入公司名称',
    phonePlaceholder: '请输入手机号码',
    phoneMissing: '"手机号码有误，请重填',
    reenterpassword: '情重新输入密码',
    passmissing: '密码不一致',
    usernameRequired: '用户名不能为空',
    passwordRequired: '密码不能为空',
    captchaRequired: '验证码不能为空',
    captchaError: '验证码错误',
    loginSuccess: '登录成功',
    loginFailed: '登录失败'
  },
  user: {
    title: '人员管理',
    title1: '用户信息',
    rowindex: '序号',
    usertype: '用户类型',
    username: '用户名',
    shenhequanxian: '审核权限',
    xiangmuquanxian: '项目管理权限',
    phonenumber: '手机号码',
    mima: '密码',
    quemima: '确认密码',
    Confirm: '确认',
    caozuo: '操作',
    bangdingweixin: '绑定微信',
    startpass: "输入原始密码",
    newpass: "新密码确认",
    innewpass: '输入新密码',
    xiugaimima: '修改密码',
    empty: '不可为空',
    newoldas: '新旧密码不可相同',
    phonePlaceholder: '请输入手机号码',
    phoneMissing: '"手机号码有误，请重填',
    passmissing: '密码不一致',
    bianji: '编辑',
    picupdata: '图片上传',
    clickpic: '点击上传logo图片',
    logosize: 'logo图片尺寸要求208*66px',
    beisize: '顶部背景图片尺寸要求896*66px',
    clicbeipic: '点击上传背景图片',
    logiopreview: 'logo图片预览',
    beijingpreview: "顶部背景图片预览",
    weixinbind: '微信绑定',
    weixinunbind: '微信解绑',
    clickcalcelbind: '点击取消绑定',
    clickcalcelunbind: '点击绑定微信',
    comfirmbind: '已绑定',
    cjsucess: '创建成功',
    cjfail: '创建失败',
    delelogin: '是否删除logo',
    delebeijing: '是否删除顶部背景图片',
    sfbind: '是否解绑',
    bindsu: '解绑成功',
    calceljie: '已取消解绑',
    sava: '保存',
    delete: '删除',
    adduser: '新增用户',
    bianjianuser: '修改信息',
    deletedata: '此操作将删除该用户, 是否继续?'
  },
  pending: {
    indexrows: '序号',
    type: '类型',
    name: '名称',
    time: '时间',
    caozuo: '操作',
    rightdeal: '立即处理',
    selectItem: '请选择需要删除的事项',
    deletedata: '确定删除?'
  },
  buildingProj: {
    indexrows: '序号',
    status: '状态',
    projectname: '项目名称',
    startstime: '开始时间',
    endtime: '结束时间',
    caozuo: '操作',
    changedeal: '切换到此项目'
  },
  caiji: {
    indexrows: '序号',
    renwuname: '任务名',
    status: '状态',
    time: '时间',
    caozuo: '操作',
    caozuodetail: '操作详情',
  },
  DevData: {
    shebeiname: '设备名称',
    wenjianDownload: '文件下载',
    Download: '下载'
  },
  dtuTaskMenu: {
    indexrows: '序号',
    rows: '序号',
    dingtime: '定时',
    everyday: '每天',
    everyinge: '每隔一天发生一次',
    duankoutype: '端口类型',
    status: '状态',
    starttime: '开始时间',
    jiangetime: '间隔时间',
    monitorType: '监测点类型',
    monitorbianhao: '监测点编号',
    monitorId: '监测点ID',
    caozuo: '操作',
    taskinfo: '任务信息',
    taskstatus: '任务状态',
    jiangemin: '间隔(分钟)',
    celiangshuliang: '测量单元数量',
    celiangfangxiang: '测量单元方向',
    monitorTypeobj: '监测对象',
    computed: '计算方向',
    openlvbo: '启用滤波',
    moniname: '模拟量名称',
    dtuid: 'DTU设备ID',
    longyouhua: '长期偏移优化',
    chuanganqi: '传感器深度(高程)',
    adress: '地址',
    basePoint: '基准点',
    linexian: '测线基准点',
    cankaodian: '参考点',
    chuantype: '传感器类型',
    fenbianlv: '分辨率',
    caiyangcisu: '采样次数',
    liangcheng: '量程',
    celiangfangshi: '测量方式',
    computedgongshi: '计算公式',
    danwei: '单位',
    jizhunposition: '基准位置',
    injechuan: '接入温度传感器',
    excmple: "例：深度10.0米应输入-10.0",
    beizhu: '备注',
    expleone: '近端是指测定位置0m处，远端是指测点位置最远处',
    expletwo: '具体安装形式对应的设置参数请查看全向位移计使用说明',
    remarkone: ' 当设置参考点时,即测线基准点为动基点,用于跨测线传递竖向位移,计算方法为:本测点的竖向位移值= 本测量单元液位高度 - 测线基准点液位高度 + 参考点位移值。',
    remarktwo: ' 为了保证测量数据传递的实时性,本测线内所有测点设置的采集时间至少晚于参考点采集时间2分钟。',
    cheap: '任何传感器都存在零漂这个物理特性且无法避免，滑动测斜仪可以通过正反测来相互抵消，固定式测斜仪无法实现正反测。',
    cheap1: '为了消除零漂，平台会自动将斜率低于零漂消除阈值的当作没有变化来处理，因此数据显得异常稳定。',
    cheap2: '该零漂消除的算法是我们首先提出的，目前行业内还没有，因此第一次接触我们的产品可能会觉得数据不正常',
    cheap3: '该算法只会消除慢速的飘移，不会削减开挖导致的快速变形，所以不影响对开挖时的监测',
    cheap4: '请您放心使用。',
    cixia: "点击此处下载",
    jizhou: '监测轴',
    tongdao: '通道选择',
    addrenwu: '新增任务',
    bianjirenwu: '编辑任务',
    guanliadd: '如需加密采集频率，请联系后台管理员',
    mintime: '间隔时间设置限制最小30',
    timeempty: '开始时间不可为空',
    chuantypemes: '请选择传感器类型',
    minitypeempty: '监测点类型不可为空',
    canempty: '参考点不能为空',
    canself: '参考点不能为自身',
    cebasaline: '测线基准点不能为空',
    rowzheng: '序号必须为正整数',
    addressempty: '地址不能为空',
    numinput: '请输入数值0~255',
    deepempty: "传感器深度(高程)不可为空",
    xuanchuantype: '请选择传感器类型',
    zidingzheng: '自定义输入内容只能为整数',
    zishuempty: '自定义输入内容不能为空',
    moniempty: '模拟量名称不能为空',
    biceempty: '监测点编号不可为空',
    dtuIdempty: 'DTU设备ID不可为空',
    compuempty: '计算公式不能为空',
    danweiempty: '单位不能为空',
    jianzhouempty: '监测轴不能为空',
    bianhaoempty: '编号不可为空',
    wuxian:'无线',
    xuanzetime:'选择日期时间',
    qingshurudizhi:'请输入地址',
    qingshuruxuhao:'请输入序号',
    qingshutujisuangongsi:'请输入计算公式',
    qingshurudanweimijngch:'请输入单位名称',
    qingshuruDTu:'请输入DTU设备ID',
    qingshurdanyuanshul:'请输入单位数量',
    qingshurceliangdanyuanshul:'请输入测量单元数量',
    qingshurucelgongshi:'请输入测量公式',
    qingshurufenbianlv:'请输入分辨率',
    qingshuruliangcheng:'请输入量程',
    qingxuanzecelianghduixiang:'请选择监测对象',
    congjinyuan:'从近端向远端观察',
    qingshurcefang:'请输入测量单元方向',
    qingcaijicish:'请输入采样次数',
    pleasejisuanfangxinag:'请输入计算方向',
    qingxuanzecankaodian:'请选择参考点',
    qingxuanzecexianjizhuandian:'请选择测线基准点',
    jizhuandian:'请选择基准点',
    ceju:'测距内插为0.5m',
    jiancezhoufangxia:'请选择监测轴方向',
    jiancebianhao:'请输入监测点编号',
    shuru:'请选择',
    qingnum:'请输入数值',
    qingchuangao:'请输入传感器深度(高程)',
    jiken:'基坑',
    matou:'码头',
    bianma:'边码',
    danciceliang:'单次测量',
    zidonglianxucel:'自动连续测量',
    qiangwending:'强稳定',
    wending:'稳定',
    guanbi:'关闭',
    zidingyi:'自定义',
    pianlm:'偏灵敏',
    humianchaokengnei:'弧面朝坑内',
    humianchaokengwai:'弧面朝坑外',
    podi:'弧面朝坡底',
    potop:'弧面朝坡顶',
    huhai:'弧面朝海（河）侧',
    hance:'弧面朝岸侧',
    huazuo:'前方朝海（河）测，滑轮组电缆出线朝左',
    huayou:'前方朝海（河）测，滑轮组电缆出线朝右',
    hushang:'弧面朝上',
    huxia:'弧面朝下',
    huleft:'弧面朝左',
    huright:'弧面朝右',
    boxia:'从上往下',
    xiabo:'从下往上',
    jinduan:'近端',
    yuanduan:'远端',
    beforeleft:'前方朝坑内，滑轮组电缆出线朝左',
    beforeright:'前方朝坑内，滑轮组电缆出线朝右',
    poleftzuo:'前方朝坡底，滑轮组电缆出线朝左',
    polrightyou:'前方朝坡底，滑轮组电缆出线朝右',
    outlinetop:'出线方向朝上',
    outlinebot:'出线方向朝下',
    outlineleft:'出线方向朝左',
    outlineright:'出线方向朝左',
    DTutype:'DTU类型',
    yuanchengmima:'远程密码'


    



    

  },
  Alertpush: {
    Chadecide: '常规设备',
    Zhudecide: '专用设备',
    Numberwaring: '数据预警',
    Dtucharyichang: 'DTU充电异常',
    Dtuclose: 'DTU未正常开机',
    Dtuellow: 'DTU电量低',
    indexrows: '序号',
    jiancetype: '监测点类型',
    danliange: "单次变化量",
    calliang: '累计变化量',
    caozuo: '操作',
    tuiding: '推送退订',
    test: '推送测试',
    orderread: "微信订阅",
    inputbianhua: '请输入变化速率',
    inputleiji: '请输入累计变化量',
    pushsuceess: '推送退订功能已完成！',
    setsuccess: '设置成功',
    waringtime: '预警推送时间',
    orderdelete: '是否删除该预警值',
    pushread: '推送测试信息已发送，请移至微信查看',
    pushtimed: '请先设置预警信息推送时间！',
    yujingset: '预警信息设置完成',
    yujingweiset: '预警线设置未完成',
    onceset: '单次变化量阈值不能为空',
    twoset: '累计变化量阈值不能为空'
  },
  // 未审核
  uncompletedAudit: {
    indexrows: '序号',
    projectname: '项目名称',
    updatetime: '提交时间',
    shenhetime: '审核时间',
    ananyyuan: '分析人员',
    shenheyuan: '审核人员',
    shenresult: '审核结果',
    analytime: '分析时间',
    enjeerinfo: '工程基本信息',
    weishenhe: '未审核',
    enjeername: '工程名称',
    enjeerbianhao: '工程编号',
    enjeeradress: '工程地址',
    buildingwei: '建筑单位',
    ananyyuaninfo: '分析人员信息',
    reason: '理由',
    checkbiao: '查看报表',
    readbob: '确定需要撤回',
    bosucessd: '撤回成功',
    quxiaosucessd: '已取消撤回',
    caozuo: "操作"
  },
  // 未审核
  completedAudit: {
    indexrows: '序号',
    projectname: '项目名称',
    updatetime: '提交时间',
    shenhetime: '审核时间',
    ananyyuan: '分析人员',
    shenheyuan: '审核人员',
    shenresult: '审核结果',
    analytime: '分析时间',
    enjeerinfo: '工程基本信息',
    enjeername: '工程名称',
    enjeerbianhao: '工程编号',
    enjeeradress: '工程地址',
    buildingwei: '建筑单位',
    ananyyuaninfo: '分析人员信息',
    reason: '理由',
    checkbiao: '查看报表',
    readbob: '确定需要撤回',
    bosucessd: '撤回成功',
    quxiaosucessd: '已取消撤回',
    caozuo: "操作",
    read: '查看',
    bohui: '驳回',

  },
  // 项目管理
  ProjectManagement: {
    ProjectManagement: "项目管理",
    indexrows: '序号',
    projectname: '项目名称',
    starttime: '开始时间',
    anayquan: '分析权限',
    shenhe: '审核',
    shenquan: '审核权限',
    status: '状态',
    caozuo: '操作',
    set: '设置',
    projecinfo: '项目信息',
    selectdata: '项目日期',
    needrow: '需要审核流程',
    ananyyuan: '分析人员',
    shenheyuan: '审核人员',
    endproject: '结束项目'
  },
  // 设备管理
  Equipment: {
    decide: '设备管理',
    indewrows: '序号',
    type: "类型",
    ProjectName: '项目名称',
    DeviceID: '设备ID',
    HardwareVersionNumber: '硬件版本号',
    SoftwareVersionNumber: '软件版本号',
    State: '设备状态',
    usering: '使用中',
    all: '全部',
    passload: "合格证下载",
    during: '时间段',
    decidetype: '设备类型',
    Num: '数量',
    boring: '生成',
    rechong: '重置',
    message: '请选择设备类型',


  },
  // test
  ChildPrj: {
    ministatus: '监测点状态',
    minitotal: '监测总数',
    yichang: '异常监测点总数',
    projectinfo: '项目信息',
    projectname: "项目名称",
    shenhe: '审核流程',
    shenheyuan: '审核人员',
    starttime: '开始时间',
    analy: '分析人员',
    list: 'DTU2和DTU3列表',
    indexrows: '序号',
    type: '类型',
    decideid: '设备ID',
    currenstatus: '当前状态',
    yichanginfo: '异常信息',
    charge: '充电电压',
    ele: '电量%',
    openleave: '关机/离线时间',
    planling: '计划下次开机时间',
    messqiang: '信号强度',
    yingban: '硬件版本',
    guti: '固体版本',
    shenji: '升级',
    modelstatus: '节能模式状态',
    open: '开启',
    close: '关闭',
    caozuo: '操作',
    history: '历史状态',
    renwu: '任务',
    moset: '节能模式设置',
    guread: '固体版本说明',
    newsguti: '最新固体版本',
    elemodel: '节能模式',
    starttime: '开始时间',
    jiangeshijian: '间隔时间',
    endtime: '结束时间',
    baninfo: '版本信息',
    gushen: '固件升级',
    Dtuset: 'DTU绑定设置',
    decideset: '设备状态',
    bindproject: 'DTU已绑定工程',
    zhongduan: '终端信息',
    surplusElectricity: "可用时长",
    shutdowntime: '关机时间',
    nextstarttime: '下次开机时间',
    onduty: '值班时间',
    kcode: '远程链接',
    quguxiao: "是否确定执行固件升级?",
    caoqu: '操作已取消',
    openjie: '开启节能模式，DTU间歇在线，确定执行？',
    openjie1: '关闭节能模式，DTU始终在线，确定执行?',
    setbing: '设备已绑定',
    setbing1: '设备已解绑',
    qujiechu: '是否确定解除绑定',
    resuceess: '重新绑定已成功',
    checkrtk: "GNSS/RTK设置查看：",
    bindset: "DTU绑定设置",
    DTUrest: 'DTU休眠',
    dtudecideID: 'DTU设备ID',
    Dtuonline: 'DTU在线',
    lasttime: '最后一次在线时间',
    candtu: 'DTU设置的参数会被记录，当DTU下一次在线时自动设置',
    enginfo:'工程信息',
     day:'天 ',
    hour:'时',
    fen:'分',
    jianonlie:'DTU间歇在线',
    shizhong:'DTU始终在线'
  },
  // 历史数据页面
  MonitorPointProject: {
    revalue: '充值',
    zhongduan: '终端信息',
    task: "任务",
    caozuo: '操作',
    wuonlie: '物联网到期日',
    checkxiangqing: '查看详情',
    Download: "下载",
    checkxun: '查询',
    cedianbianhao: '测点编号',
    cedianmingcheng: '测点名称',
    decideid: '设备ID',
    currentstatus: '当前状态',
    yichanginfo: '异常信息',
    ele: '电量',
    xinhaoqiangdu: '信号强度',
    lasttime: '最后一次在线时间',
    delete: '删除',
    checklocation: '查看定位',
    getlocation: "获取最新定位",
    shiyutu: '时域图',
    pinyutu: '频域图',
    quxiantu: '曲线图',
    datacai: '数据采集',
    insettask: '定时任务',
    canset: '参数设定',
    yuzhiset: '阈值设置',
    datachange: '数据切换',
    wetxingmap: "卫星地图",
    oncedata: '单次数据',
    daydata: '日统计数据',
    celist: "测试列表",
    tembuchang: '温度补偿',
    shichengset: '支撑设置',
    datadeal: '数据处理',
    openchange: '展示切换',
    setdata: '置数：',
   zhishu:'置数',
    yitichu: '异常单元剔除',
    checkzero: '查看归零值',
    checkstart: '查看初始值',
    lieji: '累计值',
    guanvalue: '管形值',
    timeduring: '时间段',
    zhengvalue: ' 正值朝上移动，负值朝下移动',
    updetail: "超出存储上限的详细数据将被清理，如有需要请及时下载",
    downlimit: '上限',
    downq: '当前',
    indexrows: '序号',
    testtime: '测量时间',
    speedfeng: "加速度峰值(mm/s²)",
    jiaspeed: '加速度',
    sudufeng: "速度峰值(mm/s)",
    sudu: '速度',
    weiyifeng: '位移峰值(mm)',
    zhupin: '主振频率(Hz)',
    timefanwei: '时间范围:',
    fengzhicheck: '峰值检索≥',
    waterlevel: '水位',
    yeyawater: '液压水准',
    yeyawater2: '液压水准2',
    yeyawater3: '液压水准3',
    shuci: 'PTH203磁致伸缩静力水准仪',
    shuxiang: '竖向位移',
    sheepwei: '深层水平位移',
    sheepwei1: '深层水平位移EA-DHL2',
    sheepwei4: '深层水平位移EA-DHL4',
    zhicheng: '钢支撑轴力',
    hunnitu: '混凝土支撑轴力',
    maogan: '锚杆及土钉内力',
    kongxishui: '孔隙水／土压力',
    gangjiyingli: '钢筋应力',
    qingxie: '倾斜',
    qingjiao: '倾角计',
    jiguangcejuyi: '激光测距仪',
    l2yiguang: 'L2s激光测距仪',
    askjiguang: 'A100／SK100激光测距仪',
    ealjiguang: 'EA-LRF2激光测距仪',
    tuliao: '涂料裂缝',
    naodu: '挠度(竖向位移)',
    yingli: '应力应变',
    eleyin: '电阻式应变计',
    zhenxuan: '振弦式应变计',
    weiyi: '位移',
    elewei: '电阻式位移计',
    laxianshi: '拉线式位移计',
    laeahld2: '拉线式位移计EA-HLD2',
    turang: '土壤温度水分',
    turangtel: '土壤温度水分变送器RS-WS-N01-TR-1',
    Gnsswei: "GNSS位移监测",
    GNssrtk: 'GNSS／RTK',
    zhenlie: '阵列位移计',
    sheepwei3: "深层水平位移EA-DHL3",
    sheepwei4p: "深层水平位移EA-DHL4Pro",
    zhenlieea: '阵列位移计EA-DHL4Pro',
    shoulie: '收敛变形',
    zhenxie: '振动与倾角',
    zhenjiao: '振动与倾斜',
    boan: '驳岸',
    elejiao: '电解质倾角计',
    zhenxie2: '振动监测仪2',
    haomilei: '毫米波雷达',
    yuanshi: '原始值（mm）',
    leiji: '累计值（mm）',
    daychage: '日变化量',
    ceposition: ' 测点位置（m）',
    washui: '水平(m)',
    shuxia: '竖向(m)',
    restele: '剩余电量(%)',
    giveele: '供电电压(V)',
    bettery: '电池电压(mV)',
    huantel: '环境温度(℃)',
    yachajing: '压差式静力水准EA-HHL',
    guiling: '归零',
    shestart: '设置初值',
    openjigang: '打开激光',
    deexcel: '导出',
    rechong: '重新统计',
    rigindata: '原始数据导出',
    basesheep: '基准点高程',
    inport: '导入',
    lastten: '最后十次',
    historyten: '历史十次',
    all: '全部',
    decidewangluo: '测量网络编号',
    state: '状态',
    weiyivalue: '位移值',
    wendu: '温度(℃)',
    origindata: "原始数据(mm)",
    tichudata: '剔除白天数据',
    timearea: '时间区间',
    lvbo: '滤波',
    wenxiuxi: '温度修正系数',
    shoucomputer: '手动计算',
    zidongcomputer: '自动计算',
    weibaocun: '未保存',
    downset: "下载置数模版",
    upsetfile: '上传置数文件',
    starttime: '开始时间',
    liji: '立即生效',
    lijicomputer: '立即计算',
    baseheight: '基准点高程值(单位:mm)',
    liefengwidth: "裂缝宽度变化量(mm)",
    guilingvalue: '归零值',
    onlysava: '仅保存参数，不更改历史数据',
    saveset: '保存参数，并更改历史数据',
    yingbian: '应变(με)',
    yingli: '应力(MPa)',
    flexmo: '弹性模量E',
    cetestjishu: '测量计数',
    tongdaodai: '通道代码',
    passstress: '通道',
    conputerfang: '计算方法',
    lak: '拉K',
    laB: '拉B',
    yaB: "压B",
    engineer: '工程部位',
    fenbianlv: '分辨率',
    level: '等级',
    length: '长度',
    pingyi: '平移',
    jinbo: '近0波动抑制',
    longyin: '隆起抑制',
    bili: '比例',
    chushizhi: '初始值',
    dealqian: '处理前',
    dealhou: '处理后',
    dataalyi: "数据分析设置",
    deeptiao: '深度调整',
    deepfangwei: '深度范围选择',
    toubushou: '头部收敛',
    quxianping: '曲线平滑',
    cejuneicha: '测距内插为',
    fuweiyi: '负位移抑制',
    hengxiang: '横向',
    shuxiang: '竖向',
    firstzhicheng: '第一道支撑',
    secondzhicheng: '第二道支撑',
    threezhicheng: '第三道支撑',
    fourzhicheng: '第四道支撑',
    fovezhicheng: '第五道支撑',
    sixzhicheng: '第六道支撑',
    sevenzhicheng: '第七道支撑',
    eightzhicheng: '第八道支撑',
    ninezhicheng: '第九道支撑',
    tenzhicheng: '第十道支撑',
    xiaochuling: '消除零漂',
    danfangxiang: '单方向抑制',
    yushecanshu: '预设参数1',
    yushecanshu1: '预设参数2',
    cediantype: '测点类型',
    sava: '保存',
    mi: '米',
    lishidata:'历史数据',
    tichu:'剔除',
    shifoutichu:'是否剔除',
    tuchusuccess:'剔除成功',
    shebeiweizhi:'设备位置',
     shoudongcompu:'手动计算',
     save:'保存',
    setweican:'设备采用电信营运商的基站粗定位，定位误差较大（精度1km以内），定位位置仅供参考',
    caoadd:'此操作将添加新的归零值及保存校准数据, 是否继续?',
    cibaocun:'此操作将添加新的归零值（X、Y、Z轴）并保存温度校准系数和零漂消除阈值，是否继续?',
    historydatapic:'历史数据趋势图:',
    guilingdata:'归零数据',
    guilingname:'归零值名称',
    guilingbeizhu:'归零备注',
    shifouliji:'是否立即生效',
    shengxiaosucess:'立即生效成功',
    zhishuan:'置数删除成功',
    clearndata:'清洗数据',
    menxian:'门限',
    cishu:'次数',
    xiaochupiao:'消除零漂',
    jinlingbodong:'近0波动抑制',
    qingshu1o:'请输入1-100范围的数值',
    danxiang:'单向抑制',
    fuyibai:'请输入整数：-100~100',
    zhichengsetyiend:'支撑设置设置完成',
    zhichengweiend:'支撑设置设置未完成!',
    selectfan:'范围选择',
    mito:'米至',
    tiaozheng:'调整',
    xiamoshangyi:'下移为正，上移为负',
    zhengweiyi:'正位移抑制',
    weifuyizhi:'负位移抑制',
    cejuneicha:'测距内插为0.5m',
    startchart:'原始图形展示',
    inshifou:'是否进行',
    qihuan:'切换',
    quqiehuan:'已取消切换',
    cedianposition:'测点位置',
    tichubaitian:'剔除日间数据',
    shitestdata:'实测数据',
    guankouheigh:'管口高度',
    biaodingxishuB:'标定系数B',
    biaodingxishuA:'标定系数A',
    waterihie:'水头高度',
    laxianchangdu:'线缆长度',
    Adzhi:'AD值',
    chuanganbianhao:'传感器编号',
    zhoulizhi:'轴力值(kN)',
    jiancedianname:'监测点名称',
    shengyadianya:'升压电压',
    weiyibianhualiang:'位移变化量',
    yingliyingbianliang:'应变变化量',
    xinzaobi:'信噪比',
    startorigh:'原始数据',
    rainliang:'雨量',
    sunzhao:'光照',
    crayli:'风力等级',
    fengdirection:'风向',
    fengspeed:'风速',
    shidu:'湿度',
    gaocheng:'高程',
    weidu:'纬度',
   jingdu:'经度',
   startzhi:'原始值',
   cedianxuhao:'测点序号',
   shendu:'深度',
   zhoujiaodu:'轴角度',
   datastatus:'数据状态',
   setfirst:'设为初始值',
   dianzuzhi:'电阻值',
   livalue:'力值',
   shuiweigaocheng:'水位高程值',
   celianngzhi:'测量值',
   yusetcanshu1:'预设参数1',
   yusetcanshu2:'预设参数2',
   zhankai:'展开',
    shouqi:'收起',
    shanyiweizheng:'上移为正，下移为负',
    zidongpingyi:'自动平移',
    xiangxishuju:'详细数据',
    jiewendu:'接温度传感器',
    zhdong:'振动',
    yansuan:'验算',
    la:'拉',
    ya:'压',
    jisuan:'计算',
    lingmindu:'灵敏度转换系数',
    bilixishu:'比例系数K',
    jsfs:'计算方式',
    shupiweiy:'水平位移',
    testdian:'测点',
    tuichu:'退出',
    xuji:'继续',
    shifoutuchutui:'是否退出数据处理?',
    kongzhiqiID:'控制器ID',
    yiglidangen:'应力计单根钢筋截面积',
    gangjimianji:'钢筋计截面积',
    gangzong:'钢筋总截面面积',
    gagntan:'钢筋弹性模量Es ',
    suanmian:'砼的总截面面积',
    buganmian:'不包含钢筋的总截面积',
    gnggoquan:'砼的弹性模量Ec ',
    guilingpianyiliang:'归零偏移量',
    celie:'测点列表',
    weixingshu:'卫星数',
   shangchuanpic:'点击图片上传',
   tulist:'图片列表',
   daxiao:'大小',
   yanse:'颜色',
   picjihe:'图标集合',
   jicedianpeizhi:'监测点位置配置',
   zhengzhifuzhi:'正值朝上移动，负值朝下移动',
   zhushi:'注释：X（东+，西-）；Y（北+，南-）；Z（上+，下-）',
   shizhudong:'注释：X+ 朝右，X- 朝左 ；Y+ 朝上 Y- 朝下',
   zhengyiban:'负值朝坑外移动',
   fuyiban:'正值朝坑内移动',
   zhengchao:'负值朝河道外移动',
   fuchaomove:'正值朝河道内移动',
   diyutubili:'时域图比例系数',
   caijishijian:'采集时间',
   fengvalue:'峰值',
   zhendongdingshi:'振动监测仪2定时任务设置',
   upwenjian:'上传数据文件',
   julibianhua:'距离变化量(mm)',
   zcxy:'正值朝上移动',
   ccxy:'负值朝下移动',
   syz:'水平值',
   sxz:'竖向值',
  //  
   datacaosu:'数据操作成功',
   selecttimes:'请选择次数',
   selectclean:'请选择清除数据',
   menxianweizheng:'门限值为正值',
   menemty:'门限值不能为空',
   shustartvalue:'输入的初始值为数值',
   guipi:'归零偏移量为数值',
   guivshu:'归零值为数值',
   qing10:'请输入长度为1-10范围的正整数',
   weieidt:'未进行修改',
   numemty:'输入的数字不能为空',
   shichange:'是否更换测点名称',
   qingchuemty:'消除零漂不能为空',
   nodata:'无数据详情',
   zannodata:'暂时无定位数据',
   selcedian:'请选择测点编号！',
   xuanzhou:'请选择轴类型！',
   xuanfa:'请选择方向!',
   selebi:'请选择比例',
   sellong:'请选择隆起抑制',
   sedanfa:'请选择单方向抑制',
   jin0:'请选择近0波动抑制',
   retongji:'重新统计数据成功!',
   selvtime:'请选择滤波数',
   sellv:'请选择滤波',
   selength:'请选择长度',
   sellevel:'请选择等级',
   xuanyicon:'请输入隆起抑制内容',
   jinshu:'请输入近0波动抑制数据',
   againdata:'再次确认是否更改数据',
   shichangdata:'是否更改数据?',
   zshutype:'Z系列仅限输入数值类型!',
   yshutype:'Y系列仅限输入数值类型!',
   xshutype:'X系列仅限输入数值类型!',
   startempty:'初始值不能为空且数值为数值',
   enterstart:'请输入正确的初始值',
   erzhan:'暂无数据',
   yichangtichu:'异常单元剔除完成',
   yiweicheng:'异常单元设置未完成!',
   shudaup:'数据上传成功',
   pleasettui:'请先设置预警信息推送时间！',
   addsava:'填写并保存阈值！',
   tuitest:'推送测试信息已发送，请移至微信查看！',
   shuyizhi:'请输入正确的偏移量值',
   qingxuanpian:'请选择偏移量',
   startshushihh:'请输入初始值',
   xuavalue:'请选择初始值',
   xuancan:'请选择滤波参数',
   deepfan:'深度范围值最小值大于最大值请重新选择值',
   pleafu:'请勾选负位移抑制',
   fuyifan:'负位移抑制范围为1~100',
   suzhi:'支付成功',
   caopin:'操作过于频繁，请稍后再试',
   dangwu:'当前物联网卡不支持充值',
   dnochi:'当前DTU不支持充值',
   fengonly:'峰值检索只能为数值',
   zhensu:'振动监测仪2定时任务设置成功',
   setestwei:'请选择或者输入测点位置',
   xuanwabao:'请输入报警值',
   changesu:'请输入变化速率',
   shuleibian:'请输入累计变化量',
   xuanbiant:'选择测点编号',
   shiwateer:'请输入实测水位值',
   qingchuanbian:'请输入传感器编号',
   qingfo:'请输入f0值',
   qingka:'请输入拉力K值',
   qingkb:'请输入拉力B值',
   qingyk:'请输入压力K值',
   qingyb:'请输入压力B值',
   yinggangmian:'请输入应力计单根钢筋截面积',
   ganmian:'请输入钢筋总截面面积',
   tane:'请输入钢筋弹性模量Es',
   quanmian:'请输入砼的总截面面积',
   bizheng:'必须为正数',
   zhenghah:'正数在6到10000之间',
   pweima:'请使用微信扫码支付',
   weisao:'微信扫码支付',
   shuo3fan:'请输入0.01~0.3范围的数值',
   shuo1fan:'请输入0.01~1范围的数值',
   shuo150fan:'请输入整数：1~50',
   weiding:'微信扫码订阅',
   yujingtui:'预警推送时间'


  
      



  },
  // rtk
  rtk: {
    title: 'GNSS/RTK位移监测',
    addrtk: '新增GNSS/RTK位移监测网',
    rowsindex: '序号',
    status: '状态',
    mininame: "监测网名称",
    testname: '测点名称',
    lasttestname: '最后测量数据',
    unit: '单位',
    lasttesttime: '最后测量时间',
    caozuo: '操作',
    testeit: '测点名称编辑',
    peiinfo: '配置信息',
    addrtk1: '新增GNSS/RTK',
    editrtk: "GNSS/RTK位移监测测点名称修改",
    editname: '测点名称修改:',
    delesheb: '请先删除绑定的设备!',
    desheb1: '请先删除定时任务!',
    deceb2: '请先删除定时任务及绑定的设备!',
    movertk: "GNSS/RTK位移监测网配置",
    minilist: '监测点列表',
    minidata: '监测数据页面',
    shebeilist: '设备列表',
    northmost: '单北斗模式',
    addmini: '添加基准站或监测站',
    shebeiID: '设备ID',
    cebian: '测点编号',
    currentstatus: '当前状态',
    yiinfo: '异常信息',
    restele: '电量（%）',
    opentime: '关机时间',
    laststarttime: '下一次开机时间',
    caozuo: '操作',
    zhongduaninfo: '终端信息',
    jiemodel: '节能模式',
    setiing: "设置",
    changeset: '更换设备',
    weixing: '卫星仰角',
    weixingyangjiao: "卫星仰角范围：",
    dingtask: '定时任务',
    starttime: '开始时间',
    intersetime: '间隔时间',
    edit: '修改',
    waring: '报警值',
    waringred: '在卫星地图测点列表中超过报警值1、报警值2的测点分别标注为黄色，红色',
    waringone: '报警值1',
    waringsecond: '报警值2',
    sava: '保存',
    movebind: 'GNSS/RTK位移监测设备绑定',
    // hhh
    decideset: '设备状态',
    wuonlie: '物联网到期日',
    leave: '离线时间',
    comfirmbind: '已绑定',
    online: '在线',
    type: '类型',
    movezhongduan: 'GNSS/RTK位移终端信息',
    eleshuru: "电源输入(V)",
    insetshu: "内置电池(V)",
    inseteld: "内置电池剩余电量(%)",
    template: "温度(℃)",
    singqiang: '信号强度',
    upgengtime: '信息更新时间',
    fourdata: '4G到期日期',
    setingrtk: 'GNSS/RTK参数设置:',
    movejianceshe: 'GNSS/RTK位移监测更换设备ID',
    rtkweiyiset: "GNSS/RTK位移监测设置",
    decidetype: '设备类型:',
    shedeid: 'GNSS/RTK设备ID：',
    bind: "解绑",
    unbind: "绑定",
    openjie: '开启节能模式，RTK间歇在线，确定执行？',
    openjie1: '关闭节能模式，RTK始终在线，确定执行?',
    Confirmbind: '确定解绑吗?',
    Confirmunbind: '确定绑定吗?',
    rebind: "已绑定其他工程，若重新绑定本工程，会导致其他工程数据无法采集。是否确定?",
    reunbinf: "已绑定本工程的其他监测网，若重新绑定，会导致本工程的其他监测网数据无法采集。是否确定?",
    gujiangzhixing: '是否确定执行固件升级?',
    comfirntask: "确定删除定时任务吗",
    qingshucedian:'请输入测点名称',
    cexiu:'测点名称修改成功!',
    rejicemc:'请输入监测网名称',
    lengduxian:'长度在 20个字符',
    gnde:'请输入GNSS/RTK设备ID',
    pleaswei:'请输入卫星仰角',
    plesedecide:'请选择设备类型',
    pleasede:'请输入设备ID',
    pbianma:'请输入测点编号',
    pleyang:'请输入仰角卫星值',
    mibu:'两次输入密码不一致!',
    setdaneb:'单北斗模式设置成功',
    celdanbei:'取消单北斗模式设置成功',
    peweinum:'请输入卫星仰角数值',
    re1:'数值必须在 -90 到 90 之间',
    weicheng:'卫星仰角设置成功',
    rechange:'已更换了设备',
    yib:'已绑定',
    waring1:'报警值1请输入正数值且只小数点只能保留一位',
    bao2:'报警值2大于报警值1',
    baocheng:'保存成功',
    caisu:'采集任务新增成功',
    caixiu:'采集任务修改成功',
    sunse:'设备已存在',
    yij:'已解绑'


  },

  // 监测点位置图和监测点列表
  MonitorPoint: {
    position: '监测位置图',
    Minilist: '监测点位置图和监测点列表',
    caiji: '可采集',
    all: '全部',
    pic: '图片列表',
    shebeitype: '设备类型',
    caijizhuangtai: '采集状态',
    chuanganstatus: '传感器状态',
    decideid: '设备id',
    testid: '测点编号',
    lastdata: '最后一次数据',
    testtime: '测量时间',
    rest: "剩余电量",
    checkdata: '查看数据',
    indexrow: '序号',
    status: '状态',
    testbian: "测点编号",
    testname: '测点名称',
    type: '类型',
    shebeiid: '设备ID',
    unit: '单位',
    yujing: "监测预警",
    lasttime: '最后测量时间',
    shebeiwen: '设备温度',
    caozuo: '操作',
    testset: '测点名称设置',
    zuihoudata: '最后测量数据',
    renwu: '任务',
    testdata: '测试数据',
    zhongduaninfo: '终端信息',
    pushzhuandecide: '添加专用设备',
    testtype: '监测点类型',
    testbianhao: '监测点编号',
    shebeiname: '设备名称',
    jianceid: '监测设备ID',
    shebeiSn: '设备SN',
    babiaoID: '靶标ID',
    daoru: '导出',
    minidelece: '此监测点是否继续删除?',
    inputtype: '输入监测点编号',
    inputdecide: '请输入监测点设备ID',
    inputtarget: '请输入靶标ID',
    inputjiance: '请输入监测点类型',
    shebeiid1: '请输入设备名称',
    shebeidid1: '请输入设备ID',
    shebeidid2: '请输入设备SN',
    jiancelist: '监测点列表',
    daorutype: "导出类型",
    viewpic:'查看图片',
    shushitup:'初始图片',
    celpic:'测量图片'
  },

  // 设置
  head: {
    set: '设置',
    userpineng: "默认使用审批功能",
    usershenpineng: "默认使用审核功能"

  },

  common: {
    tishi: '提示',
    quxiao: '取消',
    Confirm: '确认',
    bianji: '编辑',
    delete: '删除',
    add: '新增',
    copy: '复制',
    confirmdelete: '已取消删除',
    bianjiansuccess: '修改成功',
    bianjifail: '修改失败',
    deletesuccess: '删除成功',
    deletedata: '确定删除该任务?',
    useddeteled: '已删除',
    fousu: '是否继续删除?',
    caoqu: '操作已取消',
    addsuccess: '添加成功!',
    wulocation: "暂时无定位数据",
    upsuccess: '上传成功',
    upfail: '上传失败',
    plesefail: '请求失败',
    upsize: '上传文件大小不能超过 10MB!',
    setdo: "设置完成",
    tiantime: '请填写时间',
    editmin: '修改操作正在执行，生效需等待几分钟',
    revalue: '充值',
    dtudecideID: "DTU设备状态",
    calcelcao:'操作已取消',
    yisava:'已保存',
    savexiao:'保存失败',
    shofouzhixing:"是否确定执行?",
    zhixingsucess:'执行成功'
    



  }
}


// WEBPACK FOOTER //
// ./src/i18n/locales/zh-CN.js